import network from './index';

export const getLocations = (type) => {
  return network.get('/api/business', {
    params: {
      address_type: type
    }
  });
};